import React from 'react';
import style from './EarningsCall.module.css';
import AccordionComponent from '../AccordionComponent/AccordionComponent';

const EarningsCall = ({ earnings_call_transcript, current_user }) => {
  if (!earnings_call_transcript || !earnings_call_transcript.summary) {
    return null
  }

  if (!current_user || !current_user.active_pro_subscription) {
    // limit to 3 highlights
    earnings_call_transcript.summary = earnings_call_transcript.summary.slice(0, 3);
  }

  const accordion = earnings_call_transcript?.summary?.length > 0 && earnings_call_transcript.summary.map((highlight, index) => {
    return <AccordionComponent title={highlight.title} description={highlight.description} key={index} />;
  });

  return (
    <div className={style.box}>
      <h3 className={style.title}>
        Earnings Call Q{earnings_call_transcript.quarter} {earnings_call_transcript.year}
      </h3>
      <p className={style.subtitle}>
        {formatDate(earnings_call_transcript.date)} - AI Summary
      </p>

      <div>
        {accordion}
      </div>

      { (!current_user || !current_user.active_pro_subscription) && (
        <div className={style.proBanner}>
          <h4>Exclusive for Stockcircle Pro members</h4>
          <a href={current_user ? '/pro' : '/join'} className={style.proLink}>
            <span>Sign up</span>
            <img src="/react/phosphor/caret-right-bold.svg" alt="Sign Up" width="12" height="12" />
          </a>
        </div>
      )}
    </div>
  );
};

function formatDate(date) {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return new Date(date).toLocaleDateString('en-US', options);
}

export default EarningsCall;